import moment from 'moment'

export const formatDateUTC = (date: Date) => {
    return moment(date).utc()
}